// src/components/AboutContent.js
import React from 'react';
import './CleaningContent.css'; // Assuming you have a CSS file for styling


const CleaningContent = () => {
  return (
    <div className="dental-cleaning">
        <div className="dental-cleaning-overview-container">
            <div className="dental-cleaning-overview-info">
              <h2 className="dental-cleaning-overview-header">Dental Exams & Cleanings</h2>
              <div className="dental-cleaning-custom-line"></div>
              <p className="dental-cleaning-text">
                  A preventive program is a cooperative effort by the patient, dentist, and dental staff to preserve the natural dentition and supporting structures by preventing the onset, progress, and recurrence of dental diseases and conditions.
              </p>
              <p className="dental-cleaning-text">
                 To assist in your prevention process, we provide regular dental exams, cleanings, and x-rays. Sealants and fluoride are also great preventive treatments that help protect the teeth. Check out the information below to learn more about what to expect during your dental exam and cleaning appointments.
              </p>
            </div>

            <div className="dental-cleaning-overview-image">
              <div className="dental-cleaning-image-container">
                <img 
                  src="/images/dental-cleaning.jpeg" 
                  alt="Dental Practice" 
                  className="dental-cleaning-1"
                />
              </div>
            </div>
        </div>
        <div className="dental-cleaning-description-container">
            <div className="exam-description-container">
              <h2 className="exam-description-header">Dental Exams — What Should I Expect?</h2>
              <div className="exam-description-custom-line"></div>
              <p className="exam-description-text">
                A comprehensive dental exam will be performed by your dentist at your initial dental visit.  At regular check-up exams, your dentist and hygienist will include the following:
              </p>
              <ul className="exam-description-list">
                <li>
                  <strong>Examination of diagnostic X-rays (radiographs):</strong> Essential for detecting decay, tumors, cysts, and bone loss. X-rays also help us determine tooth and root positions.
                </li>
                <li>
                  <strong>Oral cancer screening:</strong> Checking the face, neck, lips, tongue, throat, tissues, and gums for any signs of oral cancer.
                </li>
                <li>
                  <strong>Gum disease evaluation:</strong> Checking the gums and bone around the teeth for any signs of periodontal disease.
                </li>
                <li>
                  <strong>Examination of tooth decay:</strong> Checking all tooth surfaces for decay with special dental instruments.
                </li>
                <li>
                  <strong>Examination of existing restorations:</strong> Checking current fillings, crowns, etc.
                </li>
              </ul>
            </div>

            <div className="cleaning-description-container">
              <h2 className="cleaning-description-header">Dental Cleanings — What Should I Expect?</h2>
              <div className="cleaning-description-custom-line"></div>
              <p className="cleaning-description-text">
                Professional dental cleanings (dental prophylaxis) will include a dental exam and the following:
              </p>
              <ul className="cleaning-description-list">
                <li>
                  <strong>Removal of calculus (tartar):</strong> Calculus is hardened plaque that has been left on the tooth for some time and is now firmly attached to the tooth surface.  Calculus forms above and below the gum line and can only be removed with special dental instruments.
                </li>
                <li>
                  <strong>Removal of plaque:</strong> Plaque is a sticky, almost invisible film that forms on the teeth. It is a growing colony of living bacteria, food debris, and saliva.  The bacteria produce toxins (poisons) that inflame the gums, and this inflammation is the start of periodontal disease!
                </li>
                <li>
                  <strong>Teeth polishing:</strong> Polishing removes stains and plaque that is not otherwise removed during tooth brushing and scaling.
                </li>
              </ul>
            </div>
        </div>
    </div>
  );
};

export default CleaningContent;